import { render, staticRenderFns } from "./SupplementInfo.vue?vue&type=template&id=668514a5"
import script from "./SupplementInfo.vue?vue&type=script&lang=js"
export * from "./SupplementInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports